<div class="row" id="divContainer">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <ul class="nav nav-tabs nav-tabs-custom" id="ulTabList">

          <li class="nav-item" id="liMonth">
            <a class="nav-link active" data-toggle="tab" href="#tabMonth" role="tab" title="Month"
               (click)="GetPraList('Month')">
              Tracker
            </a>
          </li>

          <li class="nav-item" id="liProblemFuture">
            <a class="nav-link" data-toggle="tab" href="#tabProblemFuture" role="tab" title="Problem-Future" (click)="GetPraList('ProblemFuture')">
              Problem-Future
            </a>
          </li>

          <li class="nav-item" id="liQueries">
            <a class="nav-link" data-toggle="tab" href="#tabQueries" role="tab" title="Queries"
               (click)="GetPraList('Queries')">
              Queries
            </a>
          </li>

          <li class="nav-item" id="liResolved">
            <a class="nav-link" data-toggle="tab" href="#tabResolved" role="tab" title=" Query Resolved"
               (click)="GetPraList('Resolved')">
              Query Resolved
            </a>
          </li>

        </ul>

        <div class="control-sidebar control-sidebar panelBox" style="display: none;" id="divFilterPanel">
          <h5>Data Filter<i class="fas fa-times" (click)="HideFilterPanel()" title="Close"></i></h5>
          <hr />
          <div class="divFilter" id="divFilter">
            <br />
            <div class="row">

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="ddlFilterDateType">Date Type</label>
                  <select id="ddlFilterDateType" class="form-control">
                    <option *ngFor="let item of dateTypes" [value]="item.value">
                      {{ item.text }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-6" name="FromDate">
                <div class="form-group">
                  <label for="txtFilterFromDtList">From Date</label>
                  <input type="date" class="form-control" id="txtFilterFromDtList">
                </div>
              </div>

              <div class="col-sm-6" name="ToDate">
                <div class="form-group">
                  <label for="txtFilterToDtList">To Date</label>
                  <input type="date" class="form-control" id="txtFilterToDtList">
                </div>
              </div>

              <div class="col-sm-12 divHide">
                <div class="form-group">
                  <label for="ddlFilterPulisher">Publisher</label>
                  <select id="ddlFilterPulisher" class="form-control">

                    <option *ngFor="let item of PublisherList" value={{item.ID}}>
                      {{item.PublisherCode}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-12 divHide">
                <div class="form-group">
                  <label for="ddlFilterTeamLead">Team Lead</label>
                  <select id="ddlFilterTeamLead" class="form-control" (change)="GetFilterUserList()">
                    <option value="0">All</option>
                    <option *ngFor="let item of UserLeadList" value={{item.UserID}}>
                      {{item.LoginName}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-12 divHide">
                <div class="form-group">
                  <label for="ddlFilterAllocatedUser">PRA</label>
                  <select id="ddlFilterAllocatedUser" class="form-control" multiple>
                    <option *ngFor="let item of FilterUserList" value={{item.UserID}}>
                      {{item.LoginName}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="ddlFilterJournal">TLA</label>
                  <select id="ddlFilterJournal" class="form-control" multiple>
                    <option *ngFor="let item of JournalList" value={{item.Journalcode}}>
                      {{item.Journalcode}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label>Task Name</label>
                  <select id="ddlFilterTaskName" class="form-control" multiple>
                    <option value='Admin Checklist'>Admin Checklist</option>
                    <option value='Forms In'>Forms In</option>
                    <option value='Production Checklist'>Production Checklist</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label>Task Status</label>
                  <select id="ddlFilterStatus" class="form-control" multiple>
                    <option value="Pending">Current</option>
                    <option value="Saved">Saved</option>
                    <option value="Problem">Problem</option>
                    <option value="Future">Future</option>
                    <option value="Not Applicable">Not Applicable</option>
                    <option value="Late">Late</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-12" style="display:none">
                <div class="form-group">
                  <label>Feedback Type</label>
                  <select id="ddlFilterFeedbackType" class="form-control">
                    <option value="All" selected>All</option>
                    <option value="Internal">Internal</option>
                    <option value="External">External</option>
                  </select>
                </div>
              </div>

            </div>
            <br />
            <div class="col-sm-12">
              <div class="col clsCenter">
                <button type="button" id="btnGet" class="btn btn-info waves-effect waves-light"
                        title="Get" (click)="getFiltered();">
                  Search
                </button>
                &nbsp;
                <button type="button" class="btn btn-danger waves-effect waves-light" title="Reset"
                        (click)="ResetPopupFilter()">
                  Reset
                </button>

              </div>
            </div>
          </div>
        </div>

        <button type="button" id="btnFilterPanel" (click)="ShowFilterPanel()" style="display:none">Filter</button>
        <table #dataTable style="width:100%"></table>

        <button type="button" id="btn_QAResponse" (click)="show()" style="display:none">Show</button>
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog">
            <div class="modal-content" id="divQAResponse">

              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">Query Response</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>

              <!-- Modal body -->
              <div class="modal-body">
                <form #form="ngForm" id="frmQAResponse">
                  <div class="col-sm-12">

                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="txtResponse" class="control-label">Response<em>*</em></label>
                          <textarea id="txtResponse" class="form-control" rows="5"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light"
                        data-dismiss="modal" (click)="hide()">
                  Close
                </button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="updateQAResponse()">Update</button>
              </div>
            </div>
            <div id="LoadingImagePopup">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
            </div>
          </div>

        </div>


      </div>
    </div>
  </div>
</div>
